import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountSyncListQuery($filters: [Filter], $companyId: ID!) {
    Me {
      id
      Company(id: $companyId) {
        data: countSync(options: { filters: $filters })
      }
    }
  }
`
